import React from 'react';
import PropTypes from 'prop-types';
import { BsExclamationOctagonFill } from 'react-icons/bs';

const ReportNotice = ({ message }) => {
    return (
        <div className="report-notice text-center text-white my-4">
            <BsExclamationOctagonFill />
            <h3>{message}</h3>
        </div>
    );
};

ReportNotice.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ReportNotice;
